import {unknown as defaultIcon} from '@sail/icons/react/FlagIcon';
import {makeLazyIconGetter} from './lazyIconGetter';

export const getFlagIcon = makeLazyIconGetter<string>({
  load: () => import('@sail/icons/react/FlagIcon'),
  defaultIcon,
  name: 'FlagIcon',
});
